"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAsc = exports.sortDesc = void 0;
var sortDesc = function (key, transform) {
    if (transform === void 0) { transform = function (d) { return d; }; }
    return function (a, b) {
        if (transform(a[key]) < transform(b[key]))
            return 1;
        if (transform(a[key]) > transform(b[key]))
            return -1;
        return 0;
    };
};
exports.sortDesc = sortDesc;
var sortAsc = function (key, transform) {
    if (transform === void 0) { transform = function (d) { return d; }; }
    return function (a, b) {
        if (transform(a[key]) > transform(b[key]))
            return 1;
        if (transform(a[key]) < transform(b[key]))
            return -1;
        return 0;
    };
};
exports.sortAsc = sortAsc;
